import { useUserContext } from "@/components/user-context/user-context-provider";

import { LoggedInDevAI } from "./logged-in/logged-in-devai";
import { LoggedOutDevAI } from "./logged-out/logged-out-devai";

export const DevAiSignup = () => {
    const {
        user: { isUserLoggedIn }
    } = useUserContext();

    if (isUserLoggedIn) {
        return <LoggedInDevAI />;
    }

    return <LoggedOutDevAI />;
};
